let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3qjwG")).then(() => parcelRequire('gbmg4'));